<!--设置各列数据对应关系-->
<template>
  <div>
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20">
        <div style="padding: 10px;">
          <div class="actionBarStyle">
            <el-row>
              <div style="display: flex;flex-direction: column;">
                <div style="display: flex;justify-content: space-between;">
                  <div class="searchStyle" style="width: 40%;">
                    <el-button type="primary" size="medium" plain @click="back">上一步</el-button>
                    <el-button type="primary" size="medium" @click="nextStep">下一步</el-button>
                  </div>
                  <div style="color: red;font-size: 16px;display: flex;justify-content: flex-end;margin-left: 100px;">
                    <el-button type="success" size="mini" round @click="importAll">全部导入</el-button>
                    <el-button type="success" size="mini" round @click="notImportAll">全部不导</el-button>
                    <el-button type="success" size="mini" round @click="reverseSelect">反向选择</el-button>
                    <el-button type="warning" size="mini" round @click="emptyToImport">未选设为导入</el-button>
                    <el-button type="warning" size="mini" round @click="emptyToIgnore">未选设为不导入</el-button>
                  </div>
                </div>
                <div class="rowTipStyle" style="margin:10px;">
                  <div style="color: red;font-size: 16px;text-align: center;width:100%;">
                    发布成绩必须指定"姓名","学号"列,不需要显示在查询结果中的选"不导本列".学号列中并不一定要放学籍号，可以是准考证号、身份证号、或者自己编制的任意内容</div>
                </div>
              </div>
            </el-row>

          </div>
        </div>
        <div style="padding-left: 10px;padding-right: 10px;">
          <div width="100%">
            <el-table ref="dataList" :data="top100RowData" height="400" style="width: 100%"
              :header-cell-style="{background:'#eef1f6',color:'#606266'}" @cell-click="handleCellClick">
              <el-table-column label="设置各列数据是否要导入(点击表格中的数据可快速操作)" header-align="center" align="center">
                <el-table-column header-align="center" align="center" :key="col.prop" :label="col.label" width="150px"
                  :prop="col.prop" v-for="(col,k) in cols">
                  <template slot="header" slot-scope="scope">
                    <div class="columnTitleStyle">
                      <div>{{col.label}}</div>
                      <div>
                        <el-tooltip class="item" effect="dark" content="要在查询结果中显示请选择'导入本列',否则选'不导本列'" placement="top">
                          <el-select v-model="newColumnNames[k]" ref="columnSetting" placeholder="请选择"
                            @change="selectChanged(k)">
                            <el-option v-for="item in columNames" :key="item.course_name" :label="item.course_name"
                              :value="item.course_name">

                              <span v-if="item.course_name=='√导入本列'" style="color:green;">
                                {{ item.course_name }}
                              </span>
                              <span v-else-if="item.course_name=='×不导本列'"
                                style="color:red;">{{ item.course_name }}</span>
                              <span v-else-if="item.course_name=='姓名'" style="color: #3299ff;"><span
                                  style="color:red;">*</span>{{item.course_name }}(必选项)</span>
                              <span v-else-if="item.course_name=='学号'" style="color: #3299ff;"><span
                                  style="color:red;">*</span>{{item.course_name }}(必选项)</span>

                            </el-option>
                          </el-select>
                        </el-tooltip>
                      </div>
                      <div v-if="paperScores[k]>0" class="paperShowStyle">
                        <div>卷面分</div>
                        <div style="text-decoration: underline;" @click="editPaperScore(k)">{{paperScores[k]}}</div>
                      </div>
                    </div>
                  </template>
                </el-table-column>
              </el-table-column>
            </el-table>
            <el-row>
              <div class="searchStyle" style="margin-top: 20px;text-align: left;color:red;display:flex;width:100%;">
                总共{{tableData.length}}行数据<span v-if="tableData.length>100">,为提高显示速度,数据只在此显示前100条数据,但不影响数据导入.</span>
              </div>
            </el-row>

            <el-row>
              <div class="searchStyle" style="margin-top: 20px;">
                <el-button type="primary" size="medium" plain @click="back">上一步</el-button>
                <el-button type="primary" size="medium" @click="nextStep">下一步</el-button>
              </div>
            </el-row>
          </div>

        </div>

      </el-col>
    </el-row>

    <!-- Form -->
    <!-- <el-button type="text" @click="dialogFormVisible = true">打开嵌套表单的 Dialog</el-button> -->

    <el-dialog :close-on-click-modal="false" v-dialogDrag title="选择表头" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <div>
          <div class="settingRowStyle">
            <div><span style="color: red;">点击右侧的"+"或者"-"号,删除表头规整数据</span></div>
            <div class="rowContentStyle">
              <el-input-number v-model="recordNum" :min="0" label="" @change="viewRecord"></el-input-number>
            </div>
          </div>
          <div class="settingRowStyle">
            <div style="font-size: 16px;font-weight: bold;display: flex;">以下是即将导入的成绩数据(<div style="color: red;">
                {{tableData.length-recordNum}}条
              </div>)</div>
          </div>
          <div>
            <el-table :data="previewTableData" height="200" style="width: 100%"
              :header-cell-style="{background:'#eef1f6',color:'#606266'}">
              <!--               <el-table-column type="index" fixed label="序号" width="80" :index="previewIndexMethod" style="background:'#eef1f6',color:'#606266'">
               </el-table-column> -->

              <el-table-column header-align="center" align="center" :key="col.realName" :label="col.labelName"
                :prop="col.realName" v-for="(col) in previewColumnLables">
              </el-table-column>
            </el-table>
          </div>
          <div>共计{{tableData.length-recordNum}}条记录<span v-if="tableData.length>100">,为了便于预览，此处最多显示前100条数据.</span></div>

        </div>

      </el-form>
      <div>

      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelPreviewSetting">取 消</el-button>
        <el-button type="primary" @click="nextPage">下一步</el-button>
      </div>
    </el-dialog>

    <el-dialog width="30%" :close-on-click-modal="false" title="输入卷面分" :visible.sync="paperScoreDialogVisible">
      <!-- <el-form-item label="卷面分"> -->
      <div class="colStyle">
        <div class="colStyle">
          <div style="padding-right: 10px;white-space:nowrap;">{{convertCourseName(newColumnNames[currentColumn])}}卷面分
          </div>

          <div>
            <el-input type="number" v-model="currentPaperScore" autocomplete="off" placeholder="数字,如150" autofocus>
            </el-input>
          </div>
        </div>
      </div>

      <!-- </el-form-item> -->

      <div slot="footer" class="dialog-footer">
        <el-button @click="cacelSetPaperScore">取 消</el-button>
        <el-button type="primary" @click="setPaperScore">确 定</el-button>
      </div>
    </el-dialog>

    <!--添加新科目-->
    <el-dialog title="添加新科目" :visible.sync="addCourseDialogVisible" width="40%">
      <el-form :model="courseForm">
        <el-form-item label="科目名称" :label-width="formLabelWidth">
          <el-input v-model="courseForm.course_name" autocomplete="off" placeholder="输入科目名称"></el-input>
        </el-form-item>
        <el-form-item label="数据类型" :label-width="formLabelWidth">
          <el-radio-group v-model="courseForm.course_type" size="mini">
            <el-radio label="1" style="margin-bottom: 20px;margin-top: 15px;">录入的是数字类成绩,如分数</el-radio>
            <el-radio label="0" style="margin-bottom: 20px;">录入的是成绩评级或不是成绩,如名次、总分、评语等</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelAddCourse">取 消</el-button>
        <el-button type="primary" @click="addCourseSave">添 加</el-button>
      </div>
    </el-dialog>


    <!--必须选择学号列-->
    <el-dialog title="请选择学号列" :visible.sync="selectStudentNumDialogVisible" width="40%">
      <!--      <div style="font-size: 16px;margin-bottom: 10px;">“快查成绩小程序”通过“<span style="font-weight: bold;">姓名</span>”和“<span style="font-weight: bold;">学号</span>”锁定手机,即达到“<span style="color:red;font-weight: bold;">查完即锁，保护隐私</span>”的目的。</div>
      <div style="font-size: 16px;margin-bottom: 10px;">没有“学号”无法锁定查询手机,可能会造成互查成绩泄露学生个人隐私。</div>
      <div style="font-size: 16px;margin-bottom: 10px;">确实不需锁定手机,且只需要一个自定义查询条件的,如按“姓名”查询等,请点下面的按钮使用“万能快查”小程序。</div>
      <div style="font-size: 12px;margin-bottom: 10px;color:red;">*如excel文件中没有学号列,请在excel列中增加学号列再重新导入</div>
     -->
      <div style="font-size: 22px;">请选择学号！</div>
      <div style="margin-top: 10px;">如果原Excel中没有学号，可增加后重新导入。</div>
      <div style="margin-top: 10px;">如果您不想增加学号，且需要发布成绩，请点下面“红色”按钮用万能快查发布成绩。</div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="wanSearchVisible=true" type="danger">没有学号,点我用“万能快查”发布成绩</el-button>
        <el-button @click="selectStudentNumDialogVisible=false" type="primary">关闭</el-button>
      </div>
    </el-dialog>


    <!--显示万能快查-->
    <el-dialog width="50%" :close-on-click-modal="false" title="发工资发录取发分班用万能快查小程序" :visible.sync="wanSearchVisible">
      <div class="colStyle">
        <div style="font-weight: bold;">可设置任意查询条件,不锁定手机,1分钟完成发布,省时省力.扫码体验。</div>
        <div><img src="../assets/wansearch_weixin.jpg"></img></div>
      </div>

      <div>
        <div style="color:red;font-weight: bold;">“万能快查”与“快查成绩”的区别：</div>
        <div style="color:red;margin-top: 10px;">快查成绩会锁定手机，万能快查不锁定手机；快查成绩不能任意设置查询条件，万能快查可以任意设置查询条件。</div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="wanSearchVisible=false">关闭</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'
  import '../assets/global.css'

  export default {
    components: {
      MenuList,
      Header
    },
    data() {
      return {
        username: '',
        tableData: [],
        top100RowData: [],
        cols: ['', '', '', ''],
        id: '',
        dialogVisible: false,
        searchResultSettingDialogTableVisible: false,
        position: -1,
        selectedExamID: '',
        msg: '',
        configurations: [],
        showPosition: false,

        record: '', // 预览整条记录
        studentName: '', // 预览姓名
        studentNum: '', // 预览学号

        name_index: 0,
        num_index: 0,
        recordNum: 0,
        columNames: [],
        selectedColumnNames: [],
        newColumnNames: [],
        realColumnNames: [], // 选中导入字段的实际名称
        paperScores: [],
        columnCount: 0,
        rowcount: 0,
        dialogFormVisible: false,
        form: {},
        resData: '',
        loadFromMemory: 'memory',

        paperScoreDialogVisible: false,
        currentPaperScore: 0,
        currentColumn: -1,

        // 预览表格的相关数据
        previewColumnLables: [],
        previewTableData: [],

        add_column_label: '添加科目...',
        addCourseDialogVisible: false,
        formLabelWidth: '80px',
        courseForm: {
          course_name: '',
          id: '',
          course_type: ''
        },
        addColumnIndex: -1,

        SELECT_TO_IMPORT: '√导入本列',
        SELECT_TO_IGNORE: '×不导本列',

        name_index_of_head: '',
        num_index_of_head: '',

        selectStudentNumDialogVisible: false,
        wanSearchVisible: false

      }
    },
    created() {
      this.username = this.$session.get('USERNAME') // 获取session
      // console.log('当前用户：' + this.username)
      this.loadData()
    },
    methods: {

      indexMethod(index) {
        var tmpIndex = this.tableData.length - index
        return tmpIndex
      },
      previewIndexMethod(index) {
        var tmpIndex = index
        return tmpIndex
      },
      loadCourses() {
        /* let that = this
        var requestUrl = '/score/web/_get_custom_courses.jsp'

        this.axios.get(requestUrl, {
            params: {
              username: that.username
            }
          }).then(function(response) {
            console.log(response.data)

            for (var i = 0; i < response.data.length; i++) {
              var tmpObj = {
                'course_name': response.data[i].course_name,
                'is_score': response.data[i].is_score
              }

             // console.log('is_score' + response.data[i].is_score)

              // if (tmpObj.is_score === 1 || tmpObj.is_score === 0) { // 有值
              //   if (tmpObj.is_score === 1) {
              //     tmpObj.course_name = tmpObj.course_name + '成绩'
              //   }
              // } else {
              //   if (tmpObj.course_name !== '总分' && tmpObj.course_name.indexOf('排名') <= 0) {
              //     tmpObj.course_name = tmpObj.course_name + '成绩'
              //   }
              // }

              that.columNames.push(tmpObj)
            }
          })
          .catch(function(error) {
            console.log(error)
          }) */
      },
      nextStep() {
        // console.log(this.newColumnNames)

        if (this.newColumnNames.length === 0) {
          this.$alert('请选择各个列的含义,不是"姓名","学号"的根据需要选择“导入本列”或“不导本列”.')
          return
        }

        for (var i = 0; i < this.columnCount; i++) {
          if (this.isEmpty(this.newColumnNames[i])) {
            this.$alert('请选择"第' + (i + 1) + '列"代表的含义,不是"姓名","学号"的根据需要选择导入或不导入.')
            return
          }
        }

        // 校验姓名和学号
        var foundName = false
        for (var n = 0; n < this.columnCount; n++) {
          if (this.newColumnNames[n] === '姓名') {
            foundName = true
            break
          }
        }

        if (!foundName) {
          this.$alert('哪列是姓名列?请在下拉列表中选择.')
          return
        }

        var foundNum = false
        for (var l = 0; l < this.columnCount; l++) {
          if (this.newColumnNames[l] === '学号') {
            foundNum = true
            break
          }
        }

        if (!foundNum) {
          this.selectStudentNumDialogVisible = true
          // this.$alert('请指定哪列是学号列?请在下拉列表中选择.')
          return
        }

        //判断选择的列小于2列
        if (this.columnCount <= 2) {
          this.$alert('成绩单至少是3列！一列是姓名，一列是学号，至少有一列是成绩列哦，请重新设置！')
          return
        }


        this.dialogFormVisible = true
        this.realColumnNames.length = 0

        // 设置标题与实际列名对应关系
        for (var j = 0; j < this.columnCount; j++) {
          if (this.newColumnNames[j] !== this.SELECT_TO_IGNORE) {
            var keyName = j
            this.realColumnNames.push(keyName)
          }
        }

        // console.log(this.realColumnNames)
        this.previewColumnLables.length = 0
        this.previewTableData.length = 0
        this.loadPreviewData(0)
      },
      nextPage() {
        let tmpTableData = []

        // for (var p = (this.recordNum); p < this.rowcount; p++) {
        //   tmpTableData.push(this.tableData[p])
        // }

        tmpTableData = this.tableData

        console.log(this.recordNum, tmpTableData, this.newColumnNames)

        var jsList = encodeURIComponent(JSON.stringify(tmpTableData)) // 数据
        var colList = encodeURIComponent(JSON.stringify(this.newColumnNames))
        var paperScoreList = encodeURIComponent(JSON.stringify(this.paperScores))
        // console.log('colList', this.newColumnNames)
        // console.log('tmpTableData', tmpTableData)

        this.$router.push({
          name: 'exam_excel_final_preview_ex',
          params: {
            jsList: jsList,
            colList: colList,
            paperScoreList: paperScoreList,
            headIndex: this.recordNum,
            name_index_of_head: this.name_index_of_head,
            num_index_of_head: this.num_index_of_head
          }
        })
      },
      changeStatus(val, index) {
        console.log(val + index)
      },
      preStep() {
        if (this.active > 0) {
          this.active = this.active - 1
        }
      },
      back() {
        this.$router.back()
      },
      convertCourseName(selectColumnName) {
        if (this.isEmpty(selectColumnName)) {
          return selectColumnName
        }
        var tmpStr = selectColumnName.replace(/成绩/, '')
        return tmpStr
      },
      selectChanged(index) {
        // console.log('选择=', this.newColumnNames[index])
        if (this.newColumnNames[index] === '姓名') {
          this.name_index_of_head = index
        } else if (this.newColumnNames[index] === '学号') {
          this.num_index_of_head = index
          // this.$alert('请确保每个学生的学号长度至少是4个字符以上,以避免姓名和学号重复查不到成绩！',{confirmButtonText: '知道了'})
          var tmpContent = '请确保每个学生的学号长度至少是4个字符以上,以避免姓名和学号重复查不到成绩！'
          var tmpTitle = '操作提醒'
          this.$alert(tmpContent, tmpTitle, {
            confirmButtonText: '知道了'
          })

        }
        // if()

        // this.$message.error(this.newColumnNames[index])
        // this.$message.error('' + index)

        /*        if (this.newColumnNames[index] === this.add_column_label) {
                  this.addColumnIndex = index
                  this.courseForm.course_type = ''

                  this.addCourseDialogVisible = true

                  return
                } */

        // let that = this

        // if (this.newColumnNames[index] !== '不导本列' && this.newColumnNames[index] !== this.add_column_label && this
        //   .newColumnNames[index] !== '姓名' && this.newColumnNames[
        //     index] !== '学号' && this.newColumnNames[index].indexOf('排名') <= 0 && this.newColumnNames[index] !== '总分' &&
        //   this.newColumnNames[index].indexOf('成绩') > 0) {
        //   this.showPaperScoreDialog(index)
        // } else {
        // that.paperScores[index] = 0

        /*     if (this.newColumnNames[index] === '学号') {
               this.$message.warning('学号建议至少4位以上,以避免姓名和学号重复后查不到数据的问题.')
             } */
        // }
      },
      handerEditor(index, row) {
        console.log(index + '  ' + row)
      },
      viewRecord() {
        // var obj = this.tableData[this.recordNum - 1]

        var tmpStr = ''

        this.loadPreviewData(this.recordNum)

        this.record = tmpStr
      },
      viewStudentName() {
        var nameKey = '第' + (this.name_index - 1) + '列'
        let tmpObj = this.tableData[this.recordNum - 1]
        this.studentName = tmpObj[nameKey]
      },
      viewStudentNum() {
        var nameKey = '第' + (this.num_index - 1) + '列'
        let tmpObj = this.tableData[this.recordNum - 1]
        this.studentNum = tmpObj[nameKey]
      },
      loadData(loadFrom, tableData) {
        if (loadFrom === this.loadFromMemory) {
          // console.log('1')
          this.resData.datalist = tableData

          // console.log(tableData)
        } else {
          // console.log('2')
          this.resData = JSON.parse(decodeURIComponent(this.$route.params.jsList))
          this.tableData = this.resData.datalist
        }

        this.cols = []
        for (var j = 0; j < this.resData.colums.length; j++) {
          var obj = {}
          obj.label = '第' + (j + 1) + '列'
          obj.prop = '第' + j + '列'
          this.cols.push(obj)
        }
        var tmpObj = {}

        tmpObj = {
          'course_name': '姓名'
        }
        this.columNames.push(tmpObj)

        tmpObj = {
          'course_name': '学号'
        }
        this.columNames.push(tmpObj)

        tmpObj = {
          'course_name': '√导入本列'
        }
        this.columNames.push(tmpObj)

        tmpObj = {
          'course_name': '×不导本列'
        }
        this.columNames.push(tmpObj)

        // this.loadCourses()

        // that.courses = response.data

        this.columnCount = this.resData.columcount

        this.rowcount = this.resData.rowcount

        for (var i = 0; i < this.columnCount; i++) {
          this.selectedColumnNames.push('')
          // this.paperScores.push(150)
        }

        this.top100RowData = this.tableData.slice(0, 100)
      },
      setPaperScore() {
        if (this.currentPaperScore <= 0 || this.isEmpty(this.currentPaperScore)) {
          this.$message.error('请输入卷面分')
          return
        }

        this.paperScores[this.currentColumn] = this.currentPaperScore
        this.paperScoreDialogVisible = false
        this.currentPaperScore = 0

        this.$refs.dataList.doLayout()
      },
      showPaperScoreDialog(k) {
        this.currentColumn = k
        this.currentPaperScore = this.paperScores[k]
        this.paperScoreDialogVisible = true
        this.$refs.dataList.doLayout()
      },
      cacelSetPaperScore() {
        this.paperScoreDialogVisible = false
        if (this.newColumnNames[this.currentColumn].indexOf('成绩') >= 0) {
          if (this.paperScores[this.currentColumn] === 0 || this.isEmpty(this.paperScores[this.currentColumn])) {
            this.newColumnNames[this.currentColumn] = ''
          }
        }
      },
      loadPreviewData(recordNum) {
        this.previewColumnLables.length = 0
        this.previewTableData.length = 0

        // console.log(this.previewColumnLables)
        // console.log(this.previewTableData)

        // this.previewTableData = this.copyData(recordNum)
        let firstRow = this.tableData.slice(recordNum, recordNum + 1)
        this.previewTableData = this.tableData.slice(recordNum + 1, 100 + recordNum)

        for (var i = 0; i < this.realColumnNames.length; i++) {
          var p = this.realColumnNames[i]

          var keyName = '第' + p + '列'
          // var tmpLabelName=this.newColumnNames[p]
          var tmpLabelName = firstRow[0][keyName]

          var obj = {}
          if (p === this.name_index_of_head) {
            obj = {
              realName: keyName,
              labelName: '姓名'
            }
          } else if (p === this.num_index_of_head) {
            obj = {
              realName: keyName,
              labelName: '学号'
            }
          } else {
            obj = {
              realName: keyName,
              labelName: tmpLabelName
            }
          }

          this.previewColumnLables.push(obj)
        }
      },
      copyData(start) {
        let tmpArray = []
        tmpArray.length = 0

        // for (var i = start; i < this.tableData.length; i++) {
        //   tmpArray.push(this.tableData[i])
        // }
        tmpArray = this.tableData.slice(start)
        return tmpArray
      },
      rowIsEmpty(row) {

      },
      cancelPreviewSetting() {
        this.previewColumnLables.length = 0
        this.dialogFormVisible = false
        this.previewTableData.length = 0
      },
      isValidScoreRow(row, colums) {
        var isValid = true
        var hasName = false
        var hasNum = false

        for (var i = 0; i < colums.length; i++) {
          var keyName = '第' + i + '列'

          var v = row[keyName]
          if (colums[i] !== '姓名') {
            if (v !== '') {
              hasName = true
            }
          }

          if (colums[i] !== '学号') {
            if (v !== '') {
              hasNum = true
            }
          }
        }

        isValid = hasName && hasNum

        return isValid
      },
      editPaperScore(k) {
        // console.log(k)
        this.showPaperScoreDialog(k)
      },
      addCourseSave() {
        // 校验数据
        if (this.courseForm.course_name === '') {
          this.$message.error('请输入科目名称')
          return
        }

        if (this.courseForm.course_type === '') {
          this.$message.error('请选择科目类型')
          return
        }

        let that = this

        // that.$message.success(that.courseForm.course_type)

        var requestUrl = '/score/web/_add_course.jsp'
        this.axios.get(requestUrl, {
            params: {
              course_name: that.courseForm.course_name,
              course_type: that.courseForm.course_type,
              username: that.username
            }
          }).then(function(response) {
            // 更新表格的数据

            if (response.data.result === '-1') {
              that.$message.error('"' + that.courseForm.course_name + '"已经存在！')
            } else if (response.data.result === '-2') {
              that.$message.error('"' + that.courseForm.course_name + '"在系统中存在，无须重复添加！')
            } else {
              that.$message.success('添加成功！')

              var tmpName = that.courseForm.course_name
              // if (that.courseForm.course_type === '1') {
              //   tmpName = tmpName + '成绩'
              // }

              var tmpObj = {
                'course_name': tmpName
              }
              that.columNames.push(tmpObj)
              // that.$alert('添加成功！')

              that.addCourseDialogVisible = false
              that.newColumnNames[that.addColumnIndex] = tmpName
              that.courseForm.course_name = ''
              // that.newColumnNames[that.addColumnIndex] = ''
              // that.$message.success('添加成功！请点击下来框重新选择！')
              that.$message.success('添加成功！')
              // that.show_selection = true
              // that.new_position = that.tableData.length
            }
          })
          .catch(function(error) {
            console.log(error)
            that.$message(error)
            that.addCourseDialogVisible = false
          })
      },
      cancelAddCourse() {
        this.newColumnNames[this.addColumnIndex] = ''
        this.addCourseDialogVisible = false
      },
      importAll() {
        for (var i = 0; i < this.cols.length; i++) {
          if (this.newColumnNames[i] !== '姓名' && this.newColumnNames[i] !== '学号') {
            this.newColumnNames[i] = this.SELECT_TO_IMPORT
          }
        }
        this.$forceUpdate()
        this.$message.success('操作成功！')
      },
      notImportAll() {
        for (var i = 0; i < this.cols.length; i++) {
          if (this.newColumnNames[i] !== '姓名' && this.newColumnNames[i] !== '学号') {
            this.newColumnNames[i] = this.SELECT_TO_IGNORE
          }
        }
        this.$forceUpdate()
        this.$message.success('操作成功！')
      },
      reverseSelect() {
        for (var i = 0; i < this.cols.length; i++) {
          if (this.newColumnNames[i] === this.SELECT_TO_IMPORT) {
            this.newColumnNames[i] = this.SELECT_TO_IGNORE
          } else if (this.newColumnNames[i] === this.SELECT_TO_IGNORE) {
            this.newColumnNames[i] = this.SELECT_TO_IMPORT
          }
        }
        this.$forceUpdate()
        this.$message.success('操作成功！')
      },
      emptyToImport() {
        for (var i = 0; i < this.cols.length; i++) {
          if (this.newColumnNames[i] === '' || typeof(this.newColumnNames[i]) === 'undefined') {
            this.newColumnNames[i] = this.SELECT_TO_IMPORT
          }
        }
        this.$forceUpdate()
        this.$message.success('操作成功！')
      },
      emptyToIgnore() {
        for (var i = 0; i < this.cols.length; i++) {
          if (this.newColumnNames[i] === '' || typeof(this.newColumnNames[i]) === 'undefined') {
            this.newColumnNames[i] = this.SELECT_TO_IGNORE
          }
        }
        this.$forceUpdate()
        this.$message.success('操作成功！')
      },
      showWanSearch() {
        this.wanSearchVisible = true
        this.selectStudentNumDialogVisible = false
      },
      handleCellClick(row, column, cell, event) {
        var cName = column.property
        var cellValue = row[cName]

        // if (cellValue == '姓名') {
        //   this.$message('“姓名”是关键字,不能修改！')
        //   return
        // }

        // if (cellValue == '学号') {
        //   this.$message('“学号”是关键字,不能修改！')
        //   return
        // }

        var index = cName.substring(1, cName.length - 1)
        let that = this

        if ('姓名' == cellValue || '学号' == cellValue) {
          this.newColumnNames[index] = cellValue
          this.$forceUpdate()
        } else {
          this.$confirm("选择导入的列才会显示在查询结果中，要导入吗？", "要导入这一列吗？", {
            iconClass: "el-icon-question", //自定义图标样式
            confirmButtonText: "导入此列", //确认按钮文字更换
            cancelButtonText: "取消", //取消按钮文字更换
            showClose: true, //是否显示右上角关闭按钮
            type: "warning", //提示类型  success/info/warning/error
          }).then(() => {
            //确认操作
            that.newColumnNames[index] = that.SELECT_TO_IMPORT

            that.$forceUpdate()

          }).catch(() => {
            //取消操作
          })
        }



        // if (this.realColumNames[index] == cellValue && cellValue != '') {
        //   this.realColumNames[index] = ''
        // } else {
        //   this.realColumNames[index] = cellValue
        // }



      }
    }
  }
</script>

<style>
  .actionStyle {
    display: flex;
    flex-direction: column;

  }

  :header-cell-style: {
    background: '#E9EEF5';
    color: '#000'
  }

  .actionBarStyle {
    display: flex;
    justify-content: space-between;
  }

  .rowStyle {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .rowTipStyle {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .rowBtnStyle {
    display: flex;
    justify-content: flex-end;
    padding-top: 50upx;
  }

  .settingRowStyle {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid aliceblue;
    margin: 5px;
  }

  .rowContentStyle {
    display: flex;
    align-items: flex-start;
    padding-top: 20px;
    padding-bottom: 20px;
    padding-left: 20px;
  }

  .settingFormStyle {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .el-scrollbar__wrap {
    overflow-x: hidden;
  }

  .titleBarStyle {
    display: flex;
  }

  .columnTitleStyle {
    display: flex;
    flex-direction: column;
  }

  .colStyle {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .paperShowStyle {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .el-table__body-wrapper::-webkit-scrollbar {
    width: 15px;
    /*滚动条宽度*/
    height: 15px;
    /*滚动条高度*/
  }

  .el-table__body-wrapper::-webkit-scrollbar-track {
    border-radius: 10px;
    /*滚动条的背景区域的圆角*/
    -webkit-box-shadow: inset 0 0 6px rgba(238, 238, 238, 0.3);
    background-color: #eeeeee;
    /*滚动条的背景颜色*/
  }

  .el-table__body-wrapper::-webkit-scrollbar-thumb {
    border-radius: 10px;
    /*滚动条的圆角*/
    -webkit-box-shadow: inset 0 0 6px rgba(145, 143, 0143, 0.3);
    background-color: rgb(145, 143, 143);
    /*滚动条的背景颜色*/
  }
</style>



// WEBPACK FOOTER //
// src/components/exam_excel_preview_ex.vue